module.exports = __webpack_public_path__ + "img/b6-6.4de029b.png";